import {toastError} from 'app/components/toasts/liteToast';
import I18n from 'app/i18n';
import {UNPROCESSABLE_ENTITY} from 'app/utils/HttpStatuses';
import {modalAlert} from 'app/utils/modals/popups';

interface AjaxErrorXhr {
    status: number;
    responseJSON?: unknown;
}

const extractUnprocessableErrorMessage = (responseJSON: unknown): string | null => {
    if (!responseJSON || typeof responseJSON !== 'object') {
        return null;
    }

    const payload = responseJSON as Record<string, unknown>;

    if (typeof payload.message === 'string' && payload.message.length > 0) {
        return payload.message;
    }

    if (Array.isArray(payload.errors) && typeof payload.errors[0] === 'string') {
        return payload.errors[0];
    }

    const firstError = Object.values(payload).find(
        (value: unknown): value is string[] => Array.isArray(value) && typeof value[0] === 'string'
    );

    return firstError ? firstError[0] : null;
};

export const ajaxError = (xhr: AjaxErrorXhr): void => {
    const {responseJSON, status} = xhr;

    if (status === UNPROCESSABLE_ENTITY) {
        const message = extractUnprocessableErrorMessage(responseJSON);

        if (message) {
            toastError(message);
        }
        return;
    }

    modalAlert(I18n.t('server_error_try_later'));
};
